import React, { useCallback, useMemo, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

/**
 * Minimal toast helper — replaces the window.alert() calls that used to
 * interrupt every chart export and settings save.
 *
 * const { snack, showSnack } = useSnack();
 * showSnack("Chart saved to Files", "success");
 * … then render {snack}
 */
const useSnack = () => {
  const [state, setState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnack = useCallback((message, severity = "success") => {
    setState({ open: true, message, severity });
  }, []);

  const close = useCallback(
    () => setState((prev) => ({ ...prev, open: false })),
    []
  );

  const snack = useMemo(
    () => (
      <Snackbar
        open={state.open}
        autoHideDuration={4000}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={state.severity} onClose={close} variant="filled">
          {state.message}
        </Alert>
      </Snackbar>
    ),
    [state, close]
  );

  return { snack, showSnack };
};

export default useSnack;
